export default "__VITE_ASSET__cb978af5__"